import React, { useCallback } from 'react';
import { Box, Button, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { subscriptionAdminApi, getApiErrorMessage } from '../../subscriptionAdmin/api';
import { hasPermission } from '../../subscriptionAdmin/permissions';
import { useAdminFetch } from '../hooks/useAdminFetch';

export default function NotificationsTab() {
  const fetchLogs = useCallback(() => subscriptionAdminApi.listNotificationLogs(), []);
  const { data, loading, error, reload } = useAdminFetch(fetchLogs);
  const logs = Array.isArray(data) ? data : [];
  const canResend = hasPermission('notifications:resend');

  const resend = async (logId) => {
    try {
      await subscriptionAdminApi.resendNotification(logId);
      reload();
    } catch (err) {
      alert(getApiErrorMessage(err));
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Box sx={{ overflowX: 'auto', bgcolor: 'white', borderRadius: 2, boxShadow: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Channel</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log._id}>
              <TableCell>{log.channel || '—'}</TableCell>
              <TableCell>{log.status || '—'}</TableCell>
              <TableCell>{log.subject || log.templateKey || '—'}</TableCell>
              <TableCell align="right">
                {canResend && (
                  <Button size="small" onClick={() => resend(log._id)}>Resend</Button>
                )}
              </TableCell>
            </TableRow>
          ))}
          {!logs.length && (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 4, color: '#64748b' }}>
                No notification logs.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
}
